<template>
  <expandable header="Complete Blood Count (CBC)" class="mb-10">
    <b-row>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.cbc_haemoglobin"
          label="Haemoglobin"
          :disabled="isDisabled"
          @input="onInput"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.cbc_mcv"
          label="MCV"
          :disabled="isDisabled"
          @input="onInput"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.cbc_mch"
          label="MCH"
          :disabled="isDisabled"
          @input="onInput"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.cbc_mchc"
          label="MCHC"
          :disabled="isDisabled"
          @input="onInput"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.cbc_platelet_count"
          label="Platelet Count"
          :disabled="isDisabled"
          @input="onInput"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.cbc_haematocrit"
          label="Haematocrit (PCV)"
          :disabled="isDisabled"
          @input="onInput"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.cbc_total_wbc"
          label="Total WBC Count"
          :disabled="isDisabled"
          @input="onInput"
        ></input-field>
      </b-col>
    </b-row>
  </expandable>
</template>

<script>
import Expandable from "../../Expandable.vue";
import InputField from "../../form/InputField.vue";

export default {
  components: { Expandable, InputField },
  props: {
    value: {},
    isDisabled: { default: false, type: Boolean },
  },
  data() {
    return { form: {} };
  },
  methods: {
    onInput() {
      this.$emit("input", this.form);
    },
  },
  beforeMount() {
    this.form = this.value;
  },
  mounted() {
    this.onInput();
  },
};
</script>
